export const NAME = 'contactFeedback';

export const FEEDBACK_ID = {
	SUCCESS: [100, 110],
	FAIL: [201, 205, 502, 503, 504],
	NEW: 0,
	ASSIGNED: 1,
};

export const SUCCESS_GIFT = 110;

// Todo - temporary change - was 'LockedPartnerException' only - used to show popup (updateFeedback action)
export const PARTNER_LOCKED = 'cz.cpas.kcl.app.exception.LockedPartnerException';
export const CONTACT_NOT_FOUND_ERR_MSG = 'Contact not found by id';
export const dialogs = {
	PARTNER_LOCKED_DIALOG: 'PARTNER_LOCKED_DIALOG',
	PARTNER_NOT_FOUND_IN_CCD: 'PARTNER_NOT_FOUND_IN_CCD',
};

export const ERR_PARTNER_LOCKED = 401;

export const SHOW = 'Y';
